import {
  createThemes,
  DEFAULT_PALETTE,
  DEFAULT_SUBDUED_PALETTE,
} from '@bsky.app/alf'

const PRIMARY_500 = '#DC34FE'

const primaryScale = {
  primary_25: '#FDF5FE',
  primary_50: '#FBEAFE',
  primary_100: '#F7D5FE',
  primary_200: '#EFABFE',
  primary_300: '#E57BFE',
  primary_400: '#DE4CFE',
  primary_500: PRIMARY_500,
  primary_600: '#C229E6',
  primary_700: '#A320C2',
  primary_800: '#7E1896',
  primary_900: '#59126B',
  primary_950: '#3C0C48',
  primary_975: '#2A0833',
} as const

const CUSTOM_DEFAULT_PALETTE = {...DEFAULT_PALETTE, ...primaryScale}
const CUSTOM_SUBDUED_PALETTE = {...DEFAULT_SUBDUED_PALETTE, ...primaryScale}

const DEFAULT_THEMES = createThemes({
  defaultPalette: CUSTOM_DEFAULT_PALETTE,
  subduedPalette: CUSTOM_SUBDUED_PALETTE,
})

export const themes = {
  lightPalette: DEFAULT_THEMES.light.palette,
  darkPalette: DEFAULT_THEMES.dark.palette,
  dimPalette: DEFAULT_THEMES.dim.palette,
  light: DEFAULT_THEMES.light,
  dark: DEFAULT_THEMES.dark,
  dim: DEFAULT_THEMES.dim,
}

/**
 * @deprecated use ALF and access palette from `useTheme()`
 */
export const lightPalette = DEFAULT_THEMES.light.palette
/**
 * @deprecated use ALF and access palette from `useTheme()`
 */
export const darkPalette = DEFAULT_THEMES.dark.palette
/**
 * @deprecated use ALF and access palette from `useTheme()`
 */
export const dimPalette = DEFAULT_THEMES.dim.palette
/**
 * @deprecated use ALF and access theme from `useTheme()`
 */
export const light = DEFAULT_THEMES.light
/**
 * @deprecated use ALF and access theme from `useTheme()`
 */
export const dark = DEFAULT_THEMES.dark
/**
 * @deprecated use ALF and access theme from `useTheme()`
 */
export const dim = DEFAULT_THEMES.dim
